import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CopyProjects, GobalTemplate, myProjects, MyProjectsCount, PinProjects, ProjectDetails, ProjectStatusCount, RecentProjects } from "../model/MyProjects";
import { copyMyProjects, copyMyProjectsExistList, createNewCase, getGlobalTemplates, getOtherProjects, getPinProjectsList, getProjects, getRecentProjectslist, getProjectStatusCount, getSharedcases, postShareWithCustomer, putUpdateProjectStatus, removeMyProjects, updateCaseDetails, updatePinStatusProject, getRecentCustomerFeedback } from "../../services/project.service";
import { caseDetailsPayload, copyMyProjectsExistsPayload, copyMyProjectsPayload, GetMyProjectsPayload, MyProjects, UpdatePinStatusPayload } from "../../models/Myprojects";
import { http } from "../../config/HttpMethod";
import { ShareWithCustomerModel } from "../../models/ShareWithCustomerModel";
import { ESP_ENDPOINTS } from "../../services/calculations/endpoints";

interface ProjectState {
    data: myProjects[] | null;
    count: MyProjectsCount | number;
    loading: boolean;
    error: string | undefined;
    copyData: CopyProjects[] | null;
    pinData: PinProjects[];
    pinLoading: boolean;
    pinCount: number;
    recentData: RecentProjects[];
    recentLoading: boolean;
    copyDataExists: boolean;
    removeMyProject: boolean;
    selectedProject: ProjectDetails | null;
    otherProjectsData: { [key: string]: boolean | number | string | undefined | null | any }[];
    othersLoading: boolean;
    otherProjectsCount: number;
    globalTemplate: GobalTemplate[];
    templateID: string;
    sharedCases: any;
    projectStatusCount: ProjectStatusCount | null
    recentCustomerFeedback: any;
    customerFeedbackLoading: boolean;
    statusLoading: boolean;
    hasProjectAccess?: boolean;
}

export const initialState: ProjectState = {
    data: [],
    count: 0,
    loading: false,
    error: '',
    copyData: [],
    pinData: [],
    pinLoading: false,
    pinCount: 0,
    recentData: [],
    recentLoading: false,
    copyDataExists: false,
    removeMyProject: false,
    selectedProject: null,
    otherProjectsData: [],
    othersLoading: false,
    otherProjectsCount: 0,
    globalTemplate: [],
    templateID: "",
    sharedCases: [],
    projectStatusCount: null,
    recentCustomerFeedback: [],
    customerFeedbackLoading: true,
    statusLoading: true,
    hasProjectAccess: true,
}

export const getMyProjects = createAsyncThunk('myProjects/getMyProjects', async (payload: GetMyProjectsPayload) => {
    const response = await getProjects(payload);
    return response;
});

export const patchCaseDetails = createAsyncThunk('myProjects/updateCaseDetails', async ({ projectId, caseName, caseDescription }: { caseName: string, caseDescription: string, projectId: string }) => {
    const response = await updateCaseDetails(projectId, { caseName, caseDescription });
    return response;
});

export const postCreateNewCase = createAsyncThunk('myProjects/createNewCase', async (payload: MyProjects) => {
    const response = await createNewCase(payload);
    return response;
});


export const gettingOtherProjects = createAsyncThunk('myProjects/getOtherProjects', async (payload: GetMyProjectsPayload) => {
    const response = await getOtherProjects(payload);
    return response;
});

export const getPinProjects = createAsyncThunk('myProjects/getPinProjects', async () => {
    const response = await getPinProjectsList();
    return response;
});
export const getGlobalTemplate = createAsyncThunk('Project/GobalTemplates', async () => {
    const response = await getGlobalTemplates();
    return response;
});

export const updatePinStatus = createAsyncThunk('myProjects/updatePinStatus', async (payload: UpdatePinStatusPayload) => {
    const response = await updatePinStatusProject(payload);
    return response;
});

export const getRecentProjects = createAsyncThunk('myProjects/getRecentProjects', async () => {
    const response = await getRecentProjectslist();
    return response;
});

export const getCopyProjects = createAsyncThunk('myProjects/getCopyprojects', async (payload: copyMyProjectsPayload) => {
    try {
        const response = await copyMyProjects(payload);
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});

export const getRemoveMyProjects = createAsyncThunk('myProjects/removeMyProjects', async (payload: any) => {
    try {
        const response = await removeMyProjects(payload);
        return response;
    } catch (err) {
        console.log(err, 'error')
    }
});

export const getCopyProjectExistsList = createAsyncThunk('myProjects/projectExist', async (payload: copyMyProjectsExistsPayload) => {
    try {
        const response = await copyMyProjectsExistList(payload)
        return response;
    } catch (err) {
        console.log(err, 'error');
    }

});

export const makeUpdateProjectStatus = createAsyncThunk('myProjects/updateProjectStatus', async ({ id, status, updateTree }: { id: string, status: number, updateTree?: boolean }) => {
    try {
        const response = await putUpdateProjectStatus(id, status, updateTree ?? false);
        return response;
    } catch (err) {
        console.log(err, 'error');
    }

});

export const shareWithCustomer = createAsyncThunk('myProjects/shareWithCustomer', async (params: ShareWithCustomerModel) => {
    try {
        const response = await postShareWithCustomer(params)
        return response;
    } catch (err) {
        console.log(err, 'error');
    }

});

export const getSharedCases = createAsyncThunk('myProjects/getSharedCases', async (params: string) => {
    try {
        const response = await getSharedcases(params)
        return response;
    } catch (err) {
        console.log(err, 'error');
    }

});

export const loadProjectStatusCount = createAsyncThunk('myProjects/loadProjectStatusCount', async () => {
    try {
        const response = await getProjectStatusCount();
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});

export const loadRecentCustomerFeedback = createAsyncThunk('myProjects/loadRecentCustomerFeedback', async () => {
    try {
        const response = await getRecentCustomerFeedback();
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});

export const fetchHasUserProjectAccess = createAsyncThunk('auth/hasProjectAccess', async (projectId: string) => {
    const response = await http.put(`${ESP_ENDPOINTS?.CHECK_ACCESS_FOR_CUSTOMER}${projectId}`);
    return response?.data;
})

const projectsSlice = createSlice({
    name: 'myProjects',
    initialState,
    reducers: {
        setProjects(state, action) {
            state.data = action.payload?.projects;
            state.count = action.payload?.projectsCount;
        },
        setPinProjects(state, action) {
            state.pinData = action.payload?.pinProjectList;
            state.pinCount = action.payload?.count;
        },
        setRecentProjects(state, action) {
            state.recentData = action.payload;
        },
        updateSelectedProject(state, action) {
            state.selectedProject = action.payload;
        },
        setGlobalTemplate: (state, action) => {
            state.templateID = action?.payload;
        },
        setSharedCases: (state, action) => {
            state.sharedCases = action?.payload
        },
        setProjectStatusCount(state, action) {
            state.projectStatusCount = action.payload;
        },
        setHasProjectAccess(state, action) {
            state.hasProjectAccess = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getMyProjects.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getMyProjects.fulfilled, (state, action) => {
            if (action.payload) {
                state.data = action.payload?.projects;
                state.count = action.payload?.projectsCount;
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(getMyProjects.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(getCopyProjects.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getCopyProjects.fulfilled, (state, action) => {
            if (action.payload) {
                state.copyData = action.payload;
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(getCopyProjects.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(getCopyProjectExistsList.fulfilled, (state, action) => {
            if (action.payload) {
                state.copyDataExists = action.payload;
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(getSharedCases.pending, (state, action) => {
            state.sharedCases = [];
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getSharedCases.fulfilled, (state, action) => {
            if (action.payload) {
                state.sharedCases = action.payload;
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(getRemoveMyProjects.fulfilled, (state, action: any) => {
            if (action.payload) {
                state.removeMyProject = action.payload;
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(getPinProjects.pending, (state) => {
            state.pinLoading = true;
            state.error = '';
        });
        builder.addCase(getPinProjects.fulfilled, (state, action) => {
            if (action.payload) {
                state.pinData = action.payload?.pinProjectList;
                state.pinCount = action.payload?.count;
                state.pinLoading = false;
                state.error = '';
            }
        });
        builder.addCase(getPinProjects.rejected, (state, action) => {
            state.pinLoading = false;
            state.error = action.error.message;
        });

        builder.addCase(updatePinStatus.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(updatePinStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.error = '';
        });
        builder.addCase(updatePinStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(getRecentProjects.pending, (state) => {
            state.recentLoading = true;
            state.error = '';
        });
        builder.addCase(getRecentProjects.fulfilled, (state, action) => {
            if (action.payload) {
                state.recentData = action.payload;
                state.recentLoading = false;
                state.error = '';
            }
        });
        builder.addCase(getRecentProjects.rejected, (state, action) => {
            state.recentLoading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingOtherProjects.pending, (state) => {
            state.othersLoading = true;
            state.error = '';
        });
        builder.addCase(gettingOtherProjects.fulfilled, (state, action) => {
            if (action.payload) {
                state.otherProjectsData = action.payload?.projects;
                state.otherProjectsCount = action.payload?.projectsCount;
                state.othersLoading = false;
                state.error = '';
            }
        });
        builder.addCase(gettingOtherProjects.rejected, (state, action) => {
            state.othersLoading = false;
            state.error = action.error.message;
        });
        builder.addCase(getGlobalTemplate.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getGlobalTemplate.fulfilled, (state, action) => {
            if (action.payload) {
                state.globalTemplate = action.payload;
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(getGlobalTemplate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        builder.addCase(patchCaseDetails.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(patchCaseDetails.fulfilled, (state, action) => {
            if (action.payload) {
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(patchCaseDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        builder.addCase(postCreateNewCase.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(postCreateNewCase.fulfilled, (state, action) => {
            if (action.payload) {
                state.loading = false;
                state.error = '';
            }
        });
        builder.addCase(postCreateNewCase.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(loadProjectStatusCount.pending, (state) => {
            state.recentLoading = true;
            state.error = '';
        });
        builder.addCase(loadProjectStatusCount.fulfilled, (state, action) => {
            if (action.payload) {
                state.projectStatusCount = action.payload;
                state.recentLoading = false;
                state.error = '';
            }
        });
        builder.addCase(loadProjectStatusCount.rejected, (state, action) => {
            state.recentLoading = false;
            state.error = action.error.message;
        });
        builder.addCase(loadRecentCustomerFeedback.pending, (state) => {
            state.customerFeedbackLoading = true;
            state.error = '';
        });
        builder.addCase(loadRecentCustomerFeedback.fulfilled, (state, action) => {
            if (action.payload) {
                state.recentCustomerFeedback = action.payload;
                state.customerFeedbackLoading = false;
                state.error = '';
            }
        });
        builder.addCase(loadRecentCustomerFeedback.rejected, (state, action) => {
            state.customerFeedbackLoading = false;
            state.error = action.error.message;
        });
        builder.addCase(makeUpdateProjectStatus.pending, (state) => {
            state.statusLoading = true;
            state.error = '';
        });
        builder.addCase(makeUpdateProjectStatus.fulfilled, (state) => {
            state.statusLoading = false;
            state.error = '';
        });
        builder.addCase(fetchHasUserProjectAccess.fulfilled, (state, action: any) => {
            state.hasProjectAccess = action?.payload;
        })
    },
});

export const { setProjects, setPinProjects, setRecentProjects, updateSelectedProject, setGlobalTemplate, setSharedCases, setProjectStatusCount, setHasProjectAccess } = projectsSlice.actions;

export default projectsSlice.reducer;